/**
 * <zh/> 判断节点/组合是否收起
 *
 * <en/> Determine whether the node/combo is collapsed
 * @param nodeLike - <zh/>节点/组合数据 | <en/>Node/Combo data
 * @returns <zh/>是否收起 | <en/>Whether it is collapsed
 */
export function isCollapsed(nodeLike) {
    var _a;
    return !!((_a = nodeLike.style) === null || _a === void 0 ? void 0 : _a.collapsed);
}
//# sourceMappingURL=collapsibility.js.map